import classNames from "classnames";
import React from "react";
export default class Footer extends React.Component {
    render() {
        if (!this.props.sw)
            return null;
        const { previousStep, nextStep, currentStep, lastStep } = this.props.sw;
        const { canContinue, visible } = this.props;
        return (React.createElement("div", { className: classNames("split-btn-row", {
                "animate__animated animate__fadeOut": !visible
            }) },
            React.createElement("a", { href: "#", className: classNames("btn btn-outline-secondary d-inline-block", {
                    "pe-none": currentStep == 1
                }), onClick: previousStep },
                React.createElement("i", { className: "far fa-chevron-left" }),
                " Previous Step"),
            React.createElement("a", { href: "#", className: classNames("btn btn-cta btn-lg d-inline-block", {
                    "disabled": !canContinue,
                    "pe-none": !canContinue
                }), onClick: nextStep },
                "Next Step ",
                React.createElement("i", { className: "far fa-chevron-right" }))));
    }
}
